
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { DestinationDistance } from "pages/api/distance-search";
import { GetStaticPropsContext } from "next";
import {
    StoryData,
    StoryblokBlokData,
    StoryblokComponent,
    getStoryblokApi,
    useStoryblokState
} from "@storyblok/react";
import { StoryblokDataSource, VacancyProps } from "storyblok/components";
import { useState } from "react";

import { Container, Page } from "components";
import { VacancyOverview, VacancyOverviewHero } from "components/vacancies";

import { FilterOptionsProvider } from "helpers/hooks/useFilterOptions";
import { getStoryblokPageData } from "helpers/storyblok/story";
import { getVacancyRegions } from "helpers/util/getVacancyRegions";
import {
    retrieveEmploymentTypes,
    retrieveFilterDepartments,
    retrieveMysolutionVacancies
} from "lib/api/vacancies";

type PageProps = {
    initialStory: StoryData;
    initialVacancies: Array<VacancyProps>;
    departmentSalaries: Record<string, string>;
    departments: Array<StoryblokDataSource>;
    employmentTypes: Array<StoryblokDataSource>;
    regions: Array<string>;
};

function VacatureOverviewPage({
    initialStory,
    initialVacancies,
    departmentSalaries,
    departments,
    employmentTypes,
    regions
}: PageProps): JSX.Element {
    const story = useStoryblokState(initialStory);
    const { blocks, seo } = getStoryblokPageData(story);

    const [destinationsWithDistances, setDestinationsWithDistances] =
        useState<Array<DestinationDistance>>();

    return (
        <Page title={seo?.title} description={seo?.description}>
            <FilterOptionsProvider>
                <Container>
                    <VacancyOverviewHero
                        regions={regions}
                        setDestinationsWithDistances={
                            setDestinationsWithDistances
                        }
                        queryHasBeenMade={!!destinationsWithDistances}
                    />
                </Container>
                <VacancyOverview
                    initialVacancies={initialVacancies}
                    isZzp={false}
                    departmentSalaries={departmentSalaries}
                    departments={departments}
                    employmentTypes={employmentTypes}
                    regions={regions}
                    setDestinationsWithDistances={setDestinationsWithDistances}
                    destinationsWithDistances={destinationsWithDistances}
                />

                {blocks &&
                    blocks?.map((block: StoryblokBlokData) => (
                        <StoryblokComponent key={block._uid} blok={block} />
                    ))}
            </FilterOptionsProvider>
        </Page>
    );
}

 async function _getStaticProps({ preview }: GetStaticPropsContext) {
    const vacancies = await retrieveMysolutionVacancies();

    // Storyblok content
    const draftMode = preview
        ? "draft"
        : (process.env.NEXT_PUBLIC_STORYBLOK_VERSION as "draft" | "published");
    const isPreview = draftMode === "draft";

    const storyblokApi = getStoryblokApi();
    const { data: storyblokData } = await storyblokApi.getStory(
        "zorgprofessionals/vacatures",
        {
            version: draftMode
        }
    );

    // storyblok api request to get all departments and their salary indications
    const labels = await storyblokApi.getStories({
        search_term: "zorgprofessionals/vacature-detail-labels/"
    });

    //take the department name and add the salary to it in an object
    const departmentSalaries: Record<string, string> = {};
    labels.data.stories.forEach(story => {
        departmentSalaries[`${story.name}`] = story.content.salary_indication;
    });

    // get all departments for the filter
    // and filter out ZZP department
    const departments = await retrieveFilterDepartments();
    const filteredDepartments = departments.filter(
        department => department.value !== "ZZP'er"
    );
    const employmentTypes = await retrieveEmploymentTypes();

    const regions = getVacancyRegions(vacancies);

    return {
        props: {
            departmentSalaries,
            departments: filteredDepartments,
            employmentTypes,
            initialStory: storyblokData?.story ?? null,
            initialVacancies: vacancies ?? null,
            preview: preview ?? false,
            regions
        },
        revalidate: isPreview ? 1 : 3600
    };
}

export default VacatureOverviewPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/zorgprofessionals/vacatures/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  